export default __webpack_public_path__ + "static/media/vue.f04dfe30.svg";